export const Component = Object.freeze({
    bitrixSaleOrderCheckout: 'bitrix:sale.order.checkout',
});